module.exports = __webpack_public_path__ + "img/3c87cf6.jpg";